import { Result } from "../models/result";
import { getFirestore, collection, getDoc, getDocs, doc } from "firebase/firestore";
import Logger from "../utils/logger";
import { SCHOOL_CONFIG } from "../config/appConfig";

export const getAppUpdate = async()=>{
    try{
        const db = getFirestore();
        const appUpdateRef = doc(db, 'updates', 'web');
        const appUpdateDoc = await getDoc(appUpdateRef);
        if(appUpdateDoc.exists()){
            const appUpdateData = appUpdateDoc.data();
            return new Result({
                value: appUpdateData,
            });
        }
    }catch(ex){
        Logger.error(`Error fetching app update: ${ex}`);
        return new Result({
            message: `Error fetching app update: ${ex.toString()}`,
        });
    }
}

export const openHelpChatInWhatsapp = async(phoneNumber)=>{
    try{
        // Validate phone number
        if (!phoneNumber) {
            throw new Error('Phone number is required');
        }

        // Clean the phone number - remove all non-digit characters except +
        let cleanPhone = phoneNumber.replace(/[^\d+]/g, '');
        
        // Ensure it starts with country code
        if (!cleanPhone.startsWith('+')) {
            // If no country code, assume +91 (India)
            cleanPhone = '+91' + cleanPhone;
        }
        
        // Remove any spaces or special characters
        cleanPhone = cleanPhone.replace(/\s+/g, '');
        
        // Detect if user is on mobile device
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        
        let whatsappUrl;
        
        if (isMobile) {
            // Use WhatsApp app URL scheme for mobile devices
            whatsappUrl = `whatsapp://send?phone=${cleanPhone}`;
        } else {
            // Use WhatsApp Web for desktop
            whatsappUrl = `https://wa.me/${cleanPhone}`;
        }
        
        // Try to open WhatsApp
        const opened = window.open(whatsappUrl, '_blank');
        
        // If window.open fails (e.g., popup blocked), try alternative method
        if (!opened || opened.closed || typeof opened.closed === 'undefined') {
            // Fallback: create a temporary link and click it
            const link = document.createElement('a');
            link.href = whatsappUrl;
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        
        return new Result({
            value: true,
            message: 'WhatsApp chat opened successfully'
        });
        
    }catch(ex){
        Logger.error(`Error opening help chat in whatsapp: ${ex}`);
    }
}